var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppIframe',{key:_vm.src,staticClass:"payment-payments",attrs:{"loading-text":"Loading Tipalti Payments","src":_vm.src,"load-delay":1500,"iframe-height":_vm.iframeHeight}})}
var staticRenderFns = []

export { render, staticRenderFns }